import classNames from 'classnames';
import React from 'react';
import { toast } from 'react-toastify';
import { Notification } from "../../notification/Notification.js";
import { Typography } from "../../typography/Typography.js";
import styles from "./generateToast.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export { toast } from 'react-toastify';
const notificationTypesMap = {
  info: 'info',
  success: 'success',
  warning: 'hint',
  error: 'error',
  default: 'info',
  dark: 'info'
};

/**
 * The function will create a toast message which disappears after a specific period.
 * The generate toast function supports a config object param or the config entries as separated params
 * Example object: generateToast({ type: 'info', title: 'My title' })
 * Example params: generateToast('info', 'My title')
 * @param config
 */

export function generateToast(typeOrConfig, titleParam, contentParam, optionsParam, idParam) {
  if (typeof typeOrConfig === 'string') {
    return generateToast({
      type: typeOrConfig,
      title: titleParam,
      content: contentParam,
      options: optionsParam,
      id: idParam
    });
  }
  const {
    type,
    title,
    content,
    options,
    id,
    dataTestId
  } = typeOrConfig;
  const toastId = toast(/*#__PURE__*/_jsx("div", {
    id: id,
    "data-testid": dataTestId,
    className: classNames(styles.toast, styles[notificationTypesMap[type]]),
    children: /*#__PURE__*/_jsxs(Notification, {
      type: notificationTypesMap[type],
      dismissible: true,
      onDismiss: () => toast.dismiss(toastId),
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "h5",
        margin: false,
        children: title
      }), content]
    })
  }), {
    ...options,
    type
  });
}